import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

interface Props {
  redirectTo: string;
}

export const HardRedirect = () => {
  window.location.replace('https://www.gettruenorth.com/download');
  return null;
};

export const SoftRedirect = ({ redirectTo }: Props) => {
  const nav = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    nav({ pathname: redirectTo, search: location?.search });
  }, [nav, redirectTo, location]);

  return null;
};
